<template>
  <v-chip
    class="ps-0 pr-2 chip"
    data-private
    pill
    small
    :color="backgroundColor"
    :text-color="textColor"
    :style="
      `border: 1px solid ${borderColor || defaultBorderColor} !important;`
    "
  >
    <UserAvatar
      fontSize="10px"
      class="me-2"
      :imageSize="IMAGE_SIZES.MINI"
      :account="account"
      size="22px"
    />

    <span class="ma-0 pa-0 font-size-12 d-inline-block text-truncate">
      {{ getShortenedName(account) }}
    </span>
  </v-chip>
</template>

<script>
import _ from 'lodash'
import UserAvatar from './UserAvatar.vue'

import { IMAGE_SIZES } from 'rever-media-sdk'

export default {
  name: 'ChipAvatar',

  data() {
    return {
      IMAGE_SIZES,
    }
  },

  components: {
    UserAvatar,
  },

  methods: {
    getFirstWord(name) {
      return _.first(name.split(' '))
    },
    getTruncatedEmail: function(email) {
      return `${email
        .split('')
        .slice(0, 8)
        .join('')}...`
    },

    getShortenedName(user) {
      const name = user?.displayname ?? ''
      const lastName = user?.familyname ?? ''
      const email = user?.email ?? ''

      if (!name) return this.getTruncatedEmail(email)

      return `${this.getFirstWord(name)} ${this.getFirstWord(lastName)}`.trim()
    },
  },

  computed: {
    defaultBorderColor() {
      return 'var(--v-blue-grey-lighten2)'
    },
  },
  props: {
    account: {
      type: Object,
      required: true,
    },
    vuetifyProps: {
      type: Object,
      required: false,
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'white',
    },
    borderColor: {
      type: String,
      required: false,
    },
    textColor: {
      type: String,
      required: false,
      default: 'blue-grey darken-2',
    },
  },
}
</script>
<style lang="scss">
.chip:hover {
  background-color: transparent !important;
  cursor: default;
}
</style>
